// Reine (React-freie) Gate-Logik für den verpflichtenden offiziellen-Karten-Schritt
// der Flugplanung (Task #561). Die offizielle Länderkarte ist ein Pflichtschritt
// direkt nach Standort + Flughöhe. Ist das geplante Land NICHT freigeschaltet
// (Länder-Berechtigung, Task #522), wird der Schritt gesperrt und die Planung
// kann für dieses Land nicht fortgesetzt werden.
//
// Quelle der Wahrheit bleibt die serverseitige Prüfung (countryGate); diese
// Funktion steuert nur das UI (gesperrter Zustand + Weiter-Blockade). Sie ist
// hier extrahiert, damit sie ohne React-/RN-Importe unter dem tsx-Testrunner
// geprüft werden kann (siehe web/src/lib/__tests__/mapStepGate.test.ts).

import {
  entitlementGrantsCountry,
  type CountryEntitlementView,
} from "../../../../shared/countryEntitlements";

// True, wenn der offizielle-Karten-Schritt für das geplante Land gesperrt ist
// (Land nicht freigeschaltet). Ohne Land (noch nicht gewählt) ist nichts gesperrt.
export function isPlanningCountryLocked(
  entitlement: CountryEntitlementView | null | undefined,
  countryIso: string | null | undefined,
): boolean {
  if (!countryIso) return false;
  return !entitlementGrantsCountry(entitlement, countryIso);
}
